import React from 'react';
import { useParams } from 'react-router-dom';
import queryString from 'query-string';

import Auth0RoleDetailsContainer from '@totem/components/services/remoteAccess/auth0role/details/Auth0RoleDetailsContainer';
import Auth0RoleDetailsLayout, {
  Auth0RoleDetailsExtra,
} from '@totem/components/services/remoteAccess/auth0role/details/Auth0RoleDetailsLayout';
import Auth0RolePageTitle from '@totem/components/services/remoteAccess/auth0role/details/Auth0RolePageTitle';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import { Breadcrumb } from '@totem/types/breadcrumb';
import { getCalculatedBreadcrumb } from '@totem/utilities/breadcrumbs';

const Auth0RoleDetailsPage = () => {
  const { id } = useParams();

  const getBreadcrumbs = (routeBreadcrumbs: Breadcrumb[]): Breadcrumb[] => {
    const parsed = queryString.parse(location.search);

    if (typeof parsed.from === 'string') {
      const fromBreadcrumb = getCalculatedBreadcrumb(parsed.from);

      if (fromBreadcrumb !== null) {
        // routeBreadcrumbs[0] is always the organization crumb prepended by
        // getBaseRoutes — keep it first, then the "from" origin, then the
        // page's own static breadcrumb(s).
        return [
          routeBreadcrumbs[0],
          fromBreadcrumb,
          ...routeBreadcrumbs.slice(1),
        ];
      }
    }

    return routeBreadcrumbs;
  };

  return (
    <Auth0RoleDetailsContainer roleId={id}>
      <ContentLayout
        pageTitle={<Auth0RolePageTitle />}
        breadcrumbs={getBreadcrumbs}
      >
        <IBCard
          isCovered
          title="Role Details"
          extra={<Auth0RoleDetailsExtra />}
        >
          <Auth0RoleDetailsLayout />
        </IBCard>
      </ContentLayout>
    </Auth0RoleDetailsContainer>
  );
};

export default Auth0RoleDetailsPage;
